var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContainer4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 18.3333C1.20833 18.3333 0.815972 18.1701 0.489583 17.8438C0.163194 17.5174 0 17.125 0 16.6667V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H10C10.4583 0 10.8507 0.163194 11.1771 0.489583C11.5035 0.815972 11.6667 1.20833 11.6667 1.66667V4.25C11.9167 4.34722 12.1181 4.5 12.2708 4.70833C12.4236 4.91667 12.5 5.15278 12.5 5.41667V7.08333C12.5 7.34722 12.4236 7.58333 12.2708 7.79167C12.1181 8 11.9167 8.15278 11.6667 8.25V16.6667C11.6667 17.125 11.5035 17.5174 11.1771 17.8438C10.8507 18.1701 10.4583 18.3333 10 18.3333H1.66667ZM5.83333 4.16667C6.06944 4.16667 6.26736 4.08681 6.42708 3.92708C6.58681 3.76736 6.66667 3.56944 6.66667 3.33333C6.66667 3.09722 6.58681 2.89931 6.42708 2.73958C6.26736 2.57986 6.06944 2.5 5.83333 2.5C5.59722 2.5 5.39931 2.57986 5.23958 2.73958C5.07986 2.89931 5 3.09722 5 3.33333C5 3.56944 5.07986 3.76736 5.23958 3.92708C5.39931 4.08681 5.59722 4.16667 5.83333 4.16667Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer4);
export default __webpack_public_path__ + "static/media/Container (4).1d44645c63e3437c940b98de274725b3.svg";
export { ForwardRef as ReactComponent };